module.exports = __webpack_public_path__ + "img/multiply_green.fd5b8a44.png";